import axios from 'axios'
import endpoint from '@/config/api.endpoints'

axios.defaults.withCredentials = true
axios.defaults.baseURL = endpoint.host
axios.defaults.headers.common['Accept'] = 'application/json'
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

export default axios
